import { createAction, props } from '@ngrx/store';
import { QueryParamsModel } from '../../../../core/_base/crud';

export const loadMedReviews = createAction(
  '[MedReview] Load MedReviews',
  props<{ page: QueryParamsModel; patientId?: number }>(),
);

export const loadMedReviewsSuccess = createAction(
  '[MedReview] Load MedReviews Success',
  props<{ data: any }>(),
);

export const loadMedReviewsFailure = createAction(
  '[MedReview] Load MedReviews Failure',
  props<{ error: any }>(),
);

export const loadBamboohealthCheck = createAction(
  '[MedReview] Load MedReview Bamboohealth Check',
  props<{ triggerType: string; medReviewId: number }>(),
);

export const loadBamboohealthCheckSuccess = createAction(
  '[MedReview] Load MedReview Bamboohealth Check Success',
  props<{ data: any }>(),
);
export const loadBamboohealthCheckFailure = createAction(
  '[MedReview] Load MedReview Bamboohealth Check Failure',
  props<{ error: any }>(),
);

export const clearMedReviews = createAction('[MedReview] Clear MedReviews');
